import React from 'react';

import { ModalRawHTML } from '../../RawHTML/ModalRawHTML';
import { EmbedCodeFragment } from '../../../../graphql.schema';
import * as styles from '../index.module.scss';
export const StrapiEmbedComponent: React.FC<EmbedCodeFragment> = (props) => {
  return <ModalRawHTML className={`embed-component-wrapper ${styles.alignEmbedComponent}`} html={props.content}/>;
};
